// extracted by mini-css-extract-plugin
export default {"cookieBanner":"cookieBanner_cookieBanner__qZdrp","cookieBannerText":"cookieBanner_cookieBannerText__R0TuU","cookieBannerLink":"cookieBanner_cookieBannerLink__JTK8Z"};